<script setup>
import { computed } from 'vue'

const props = defineProps({
    difficulty: String
})

const difficultyLevel = computed(function () {
    return { beginner: 1, intermediate: 2, advanced: 3 }[props.difficulty]
})
</script>

<template>
<div class="flex items-end space-x-1">
    <div
        class="h-[12px] w-[4px] rounded"
        :class="{
            'bg-[rgba(186,146,250,1)] drop-shadow-[0px_0px_3px_rgba(186,146,250,0.8)]': difficultyLevel >= 1,
        }"
    ></div>

    <div
        class="h-[14px] w-[4px] rounded"
        :class="{
        'bg-[rgba(186,146,250,1)] drop-shadow-[0px_0px_3px_rgba(186,146,250,0.8)]': difficultyLevel >= 2,
        'bg-[rgba(37,44,97,1)]': difficultyLevel < 2
    }"
    ></div>

    <div
        class="h-[16px] w-[4px] rounded"
        :class="{
            'bg-[rgba(186,146,250,1)] drop-shadow-[0px_0px_3px_rgba(186,146,250,0.8)]': difficultyLevel >= 3,
            'bg-[rgba(37,44,97,1)]': difficultyLevel < 3
        }"
    ></div>
</div>
</template>
